import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/context/AuthContext";

export default function AcceptLearnerInvite() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/accept-learner-invite", {
        token,
        password,
        display_name: displayName || undefined,
      });
      setDone(true);
      setPassword("");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card max-w-xl space-y-6" data-testid="accept-learner-invite-page">
      <h1 className="text-base md:text-lg font-semibold">Activate learner account</h1>
      {done ? (
        <div className="space-y-4">
          <p data-testid="accept-learner-invite-success">
            Account created. You can now log in. Training feedback appears after your instructor is
            assigned and publishes feedback.
          </p>
          <Link to="/login" className="btn-primary inline-block" data-testid="accept-learner-invite-login-link">
            Log in
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {!token && (
            <p role="alert" className="text-destructive" data-testid="accept-learner-invite-no-token">
              No invitation token provided.
            </p>
          )}
          <div className="space-y-1">
            <label htmlFor="accept-learner-display-name" className="font-medium">
              Display name (optional)
            </label>
            <input
              id="accept-learner-display-name"
              data-testid="accept-learner-display-name"
              className="input"
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
            />
          </div>
          <div className="space-y-1">
            <label htmlFor="accept-learner-password" className="font-medium">
              Password (minimum 12 characters)
            </label>
            <input
              id="accept-learner-password"
              data-testid="accept-learner-password"
              className="input"
              type="password"
              required
              minLength={12}
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {error && (
            <p role="alert" className="text-destructive" data-testid="accept-learner-invite-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            className="btn-primary"
            disabled={busy || !token}
            data-testid="accept-learner-invite-submit"
          >
            {busy ? "Saving…" : "Activate account"}
          </button>
        </form>
      )}
    </div>
  );
}
